import { SlotsToClasses } from "@nextui-org/react";
import { NAV_LINKS } from "@/pages/homepage/constants/navLinks";
import NavLink from "@/pages/homepage/components/common/NavLink";

export default function MobileNavLinks({
  links = DEFAULT_LINKS,
  onClose,
  variant,
  classNames,
}: MobileNavLinksProps) {
  return links.map((link) => (
    <NavLink
      key={link.key}
      href={link.href}
      onClick={onClose}
      variant={variant}
      classNames={classNames}
    >
      {link.label}
    </NavLink>
  ));
}

export type NavLinkItem = {
  key: string;
  href: string;
  label: string;
};

interface MobileNavLinksProps {
  links?: NavLinkItem[];
  onClose?: () => void;
  variant?: "default" | "nested";
  classNames?: SlotsToClasses<"base">;
}

const DEFAULT_LINKS = NAV_LINKS.map((link) => ({
  key: link.label,
  href: link.href,
  label: link.label,
}));
